const isSubscriptionPaymentMethod = (handler: string) => {
  return (
    `${handler}`.includes('OneClick') || `${handler}`.includes('Subscription')
  );
};

export default isSubscriptionPaymentMethod;
